// 計画書の予定日 (ISO の日付文字列) の扱い。暦の日付なので Date の時差を通さず文字で比べる。

// 端末の暦の今日 (店の日付)。toISOString は UTC なので使わない
export const localToday = (now: Date = new Date()): string => {
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

// 今日より前の予定日は動かせない (済んだ訪問の日を後から予定に入れない。back も断る)
export const isPastDate = (value: string, today: string): boolean =>
  value < today

// 「10/21」。患者のページの計画書の行に並べる形
export const monthDay = (value: string): string => {
  const [, m, d] = value.split('-').map(Number)
  return `${m}/${d}`
}

// 1 つの札を替える・消す (空 = 消す)。並びは昇順・重複なし
export const replaceDate = (
  dates: string[],
  index: number,
  next: string
): string[] => {
  const rest = dates.filter((_, i) => i !== index)
  return Array.from(new Set(next ? [...rest, next] : rest)).sort()
}

// 最後の空の札で足す
export const addDate = (dates: string[], next: string): string[] =>
  next ? Array.from(new Set([...dates, next])).sort() : dates
